<template>
  <div>
    <comment-header
      :fathertitle="fathertitle"
      :childtitle="childtitle"
      :path="path"
    >
    </comment-header>
    <!-- <a-alert
      v-if="showAlertMsg"
      message="警告 消息"
      description="建议使用1920*1080分辨率的电脑,并且百分比为100%。"
      type="error"
      closable
      @close="onClose"
    /> -->
    <a-card :bordered="false">
      <a-row>
        <a-col :sm="6" :xs="24">
          <info
            title="待训练的任务"
            :value="taskStatics.prepCount"
            :bordered="true"
          />
        </a-col>
        <a-col :sm="6" :xs="24">
          <info
            title="等待处理的任务"
            :value="taskStatics.awaitCount"
            :bordered="true"
          />
        </a-col>
        <a-col :sm="6" :xs="24">
          <info
            title="正在训练的任务"
            :value="taskStatics.traningCount"
            :bordered="true"
          />
        </a-col>
        <a-col :sm="6" :xs="24">
          <info title="已完成训练任务" :value="taskStatics.completeCount" />
        </a-col>
      </a-row>
    </a-card>

    <a-card :bordered="false">
      <div slot="extra">
        <a-radio-group v-model="queryParam.status">
          <a-radio-button value="-1" @click="loadTask2(-1)"
            >全部</a-radio-button
          >
          <a-radio-button value="0" @click="loadTask2(0)"
            >待训练</a-radio-button
          >
          <a-radio-button value="4" @click="loadTask2(4)"
            >等待处理</a-radio-button
          >
          <a-radio-button value="1" @click="loadTask2(1)"
            >进行中</a-radio-button
          >
          <a-radio-button value="2" @click="loadTask2(2)">中断</a-radio-button>
          <a-radio-button value="3" @click="loadTask2(3)">完成</a-radio-button>
        </a-radio-group>
        <a-select
          placeholder="请选择项目"
          v-model="serchProjectId"
          show-search
          @select="selectProject"
          :filter-option="filterOption"
          default-value="0"
          style="margin-left: 16px; width: 200px"
        >
          <a-select-option value="0" key="all">全部项目</a-select-option>
          <a-select-option v-for="(p, i) in projectList" :value="p.id" :key="i">
            {{ p.name }}
          </a-select-option>
        </a-select>
      </div>

      <div slot="title">
        <span> 任务列表 </span>
        <a-button
          type="primary"
          style="margin-left: 30px"
          icon="plus"
          @click="add"
          >添加</a-button
        >
      </div>

      <a-table
        :columns="columns"
        :bordered="true"
        :data-source="data"
        :loading="loading"
        :scroll="{ x: 1500, y: 410 }"
        :pagination="{
          pageSize: 15,
          total: paging.totalRecords,
          current: paging.pageIndex,
          onChange: onChangepage,
        }"
      >
        <a-table
          slot="expandedRowRender"
          slot-scope="text, record"
          :columns="innerColumns"
          :data-source="buildInnerText(text)"
          :pagination="false"
        >
        </a-table>

        <div slot="status" slot-scope="text, record" class="status">
          <div v-if="text == 0">待训练</div>
          <div v-if="text == 1">训练中</div>
          <!-- <div v-if="text==2"> 中断 </div> -->
          <div v-if="text == 2">
            中断
            <a-icon
              @click="errorMsg(record)"
              style="color: red; cursor: pointer"
              type="exclamation-circle"
            />
          </div>
          <div v-if="text == 3">完成</div>
          <div v-if="text == 4">等待处理</div>
          <div v-if="text == 42">等待中断处理</div>
        </div>
        <div slot="currentStartTime" slot-scope="text, record">
          {{ text ? text : "/" }}
        </div>
        <!-- <div slot="submitTime">
          <a-select default-value="1">
            <a-select-option value="1">提交时间</a-select-option>
            <a-select-option value="2">完成时间</a-select-option>
          </a-select>
        </div> -->
        <div slot="progress" slot-scope="text, record">
          <div
            v-if="record.status == 1 || record.status == 2"
            class="list-content-item"
          >
            <a-progress :percent="record.progress.value" style="width: 180px" />
          </div>
          <div v-if="record.status == 3">已完成</div>
        </div>
        <div slot="action" slot-scope="text, record">
          <a-button
            v-if="
              record.status == 0 ||
              record.status == 2 ||
              (record.status == 3 &&
                record.networkModelName.indexOf('羽毛') == -1)
            "
            disabled="true"
            @click="start(record)"
          >
            <a-icon type="play-circle" />
            开始训练
          </a-button>
          <span v-else>
            <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
          </span>
        </div>
        <div slot="actions" slot-scope="text, record">
          <a-dropdown>
            <a-menu theme="light" slot="overlay">
              <a-menu-item class="menuItem" @click="edit(record)"
                ><a>编辑</a></a-menu-item
              >
              <a-menu-item class="menuItem" @click="remove(record)"
                ><a>删除</a></a-menu-item
              >
              <a-menu-item class="menuItem" @click="configParams(record)"
                ><a>配置参数</a></a-menu-item
              >
              <a-menu-item
                class="menuItem"
                v-if="showJson"
                @click="configParams2(record)"
                ><a>配置参数(高级)</a></a-menu-item
              >
              <a-menu-item class="menuItem" @click="openLog(record)"
                ><a>训练实时记录</a></a-menu-item
              >
              <a-menu-item
                class="menuItem"
                @click="openTrainValidateSet(record)"
                ><a>训练验证错误集</a></a-menu-item
              >
              <!-- <a-menu-item
                class="menuItem"
                v-if="record.status == 1"
                @click="setBreak(record)"
                ><a>中断</a></a-menu-item
              > -->
              <a-menu-item
                class="menuItem"
                v-if="record.status == 3"
                @click="downloadTrainModel(record)"
                ><a>下载模型(加密)</a></a-menu-item
              >
              <a-menu-item
                class="menuItem"
                v-if="record.status == 3 && showDown"
                @click="downloadTrainModel2(record)"
                ><a>下载模型(非加密)</a></a-menu-item
              >
              <a-menu-item
                class="menuItem"
                v-if="record.status == 3 && record.downloadBmodel && showDown"
                @click="downloadTrainBModel(record)"
                ><a>下载Bmodel(非加密)</a></a-menu-item
              >
              <a-menu-item
                class="menuItem"
                v-if="record.status == 3 && record.downloadBmodel"
                @click="downloadTrainBModel2(record)"
                ><a>下载Bmodel(加密)</a></a-menu-item
              >

              <a-menu-item
                class="menuItem"
                v-if="
                  record.status == 3 && record.networkModelName == '目标框检测'
                "
                @click="downloadTrtTrainModel(record)"
                ><a>下载trt(加密)</a></a-menu-item
              >
              <a-menu-item
                class="menuItem"
                v-if="
                  record.status == 3 &&
                  record.networkModelName == '目标框检测' &&
                  showDown
                "
                @click="downloadTrtTrainModel2(record)"
                ><a>下载trt(非加密)</a></a-menu-item
              >
            </a-menu>
            <a-button>更多<a-icon type="down" /></a-button>
          </a-dropdown>
        </div>
        <!-- <div class="list">
          <a-list-item :key="index" v-for="(item, index) in data">
            <a-list-item-meta :description="item.networkModelName">
              <a slot="title">{{ item.projectName }}</a>
            </a-list-item-meta>
            <div slot="actions">
              <a
                v-if="
                  item.status == 0 ||
                  item.status == 2 ||
                  (item.status == 3 &&
                    item.networkModelName.indexOf('羽毛') == -1)
                "
                @click="start(item)"
                >开始训练</a
              >
              <span v-else>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
              <a v-else-if="item.status == 1" @click="prepBreak(item)">准备中断</a>
            </div>
            <div slot="actions">
              <a-dropdown>
                <a-menu slot="overlay">
                  <a-menu-item @click="edit(item)"><a>编辑</a></a-menu-item>
                  <a-menu-item @click="remove(item)"><a>删除</a></a-menu-item>
                  <a-menu-item @click="configParams(item)"
                    ><a>配置参数</a></a-menu-item
                  >
                  <a-menu-item @click="openLog(item)"
                    ><a>训练实时记录</a></a-menu-item
                  >
                  <a-menu-item
                    v-if="item.status == 3"
                    @click="downloadTrainModel(item)"
                    ><a>下载模型</a></a-menu-item
                  >
                </a-menu>
                <a>更多<a-icon type="down" /></a>
              </a-dropdown>
            </div>
            <div class="list-content" style="flex: 6; display: flex">
              <div class="list-content-item" style="flex: 6">
                <span>资源库</span>
                <p>{{ item.resourceName }}</p>
              </div>
              <div class="list-content-item">
                <span>状态</span>
                <p v-if="item.status == 0">待训练</p>
                <p v-else-if="item.status == 1">训练中</p>
                <p v-else-if="item.status == 2">中断</p>
                <p v-else-if="item.status == 3">完成</p>
                <p v-else-if="item.status == 4">等待处理</p>
                <p v-else-if="item.status == 42">等待中断处理</p>
              </div>
              <div class="list-content-item">
                <span>提交时间</span>
                <p>{{ item.submitTime }}</p>
              </div>
              <div
                v-if="item.status == 1 || item.status == 2"
                class="list-content-item"
              >
                <a-progress
                  :percent="item.progress.value"
                  style="width: 180px"
                />
              </div>
            </div>
          </a-list-item>
        </div> -->
      </a-table>

      <train-config
        ref="trainConfig"
        @cancel="handleCancel"
        @ok="handleOk"
        :title="title"
        :visible="visible"
        :loading="confirmLoading"
        :model="mdl"
        :showAugmentation="showAugmentation"
        :showNetworkModelType="showNetworkModelType"
        :networkModelTypeList="networkModelTypeList"
        :showSeparate="showSeparate"
        :resourceList="resourceList"
        :projectList="projectList"
        :projectId="currentProjectId"
        :showrow="showrow"
        :showSemiSupervised="showSemiSupervised"
      >
      </train-config>
      <!-- <train-config-classify
       ref="trainConfigClassify"
        @cancel="handleCancel"
        @ok="handleOk"
        :title="title"
        :visible="visible"
        :loading="confirmLoading"
        :model="mdl"
        :networkModelTypeList="networkModelTypeList"
        :resourceList="resourceList"
      >
      </train-config-classify> -->

      <task-form
        ref="taskForm"
        @cancel="handleCancel1"
        @ok="handleOk1"
        :title="title1"
        :visible="visible1"
        :loading="confirmLoading1"
        :model="mdl1"
        :projectList="projectList"
      >
      </task-form>
      <train-log
        ref="trainLog"
        @isopen="isopen"
        @cancel="handleCancel2"
        :title="title2"
        :visible="visible2"
        :loading="trainLogLoading"
        :ldata="logData"
        :lcolumns="logColumns"
      >
      </train-log>

      <train-validate
        :visible="trainValidateVisible"
        :loading="trainValidateLoading"
        :validate="validate"
        @cancel="handleValidate"
      >
      </train-validate>

      <model-choose
        :visible="isshowChooseModel"
        :ok="chooseOk"
        :cancel="chooseCancel"
        :modelList="modelList"
      >
      </model-choose>
    </a-card>
    <json-editor
      :visible="visible6"
      :jsonData="jsonData"
      ref="jsonEditor"
      @cancel="handleCancelJson"
      @uploadJson="handleOkJson"
      @upload="changeUploadJson"
    />
  </div>
</template>

<script>
// 演示如何使用 this.$dialog 封装 modal 组件
// import TaskForm from './modules/TaskForm'
import Info from "@components/info";
import * as projectManagement from "@api/projectManage";
import * as task from "@api/task_management";
import TrainConfig from "./TrainConfig";
import TrainConfig_classify from "./TrainConfig_classify";
import * as networkmodel from "@api/networkmodel_management";
import * as networkmodeltype from "@api/networkmodeltype_management";
import * as labelFile from "@api/label_file";
import TaskForm from "./TaskForm";
import axios from "axios";
import { requestUrl } from "@utils/request_url";
import request from "@utils/request";
import TrainLog from "./TrainLog";
import CommentHeader from "@components/header";
import modelChoose from "./modelChoose.vue";
import JsonEditor from "./jsonEditor.vue";
import TrainValidate from "./TrainValidate.vue";
import ipcApiRoute from "@/utils/bridge";
const data = [];
const columns = [
  {
    title: "项目名称",
    width: 200,
    dataIndex: "projectName",
    key: "projectName",
    align: "center",
    // fixed: "left",
  },
  {
    title: "算法类型",
    width: 200,
    dataIndex: "networkModelName",
    key: "networkModelName",
    align: "center",
    // fixed: "left",
  },
  {
    title: "资源库",
    width: 330,
    dataIndex: "resourceName",
    key: "resourceName",
    align: "center",
  },
  {
    title: "状态",
    width: 100,
    dataIndex: "status",
    key: "status",
    scopedSlots: { customRender: "status" },
    align: "center",
  },
  {
    title: "提交时间",
    width: 200,
    dataIndex: "submitTime",
    key: "submitTime",
    // slots: { title: "submitTime" },
    align: "center",
  },
  {
    title: "开始时间",
    width: 200,
    dataIndex: "currentStartTime",
    key: "currentStartTime",
    scopedSlots: { customRender: "currentStartTime" },
    align: "center",
  },
  {
    title: "完成时间",
    width: 200,
    dataIndex: "lastCompleteTime",
    key: "lastCompleteTime",
    scopedSlots: { customRender: "lastCompleteTime" },
    align: "center",
  },
  {
    title: "进度",
    width: 300,
    dataIndex: "progress",
    key: "progress",
    scopedSlots: { customRender: "progress" },
    align: "center",
  },
  {
    title: "训练操作",
    width: 150,
    dataIndex: "action",
    key: "action",
    // fixed: "right",
    scopedSlots: { customRender: "action" },
    align: "center",
  },
  {
    title: "操作",
    width: 120,
    dataIndex: "actions",
    key: "actions",
    fixed: "right",
    scopedSlots: { customRender: "actions" },
    align: "center",
  },
];
const lcolunmns = [
  {
    dataIndex: "lr",
    key: "lr",
    title: "学习率",
  },
  {
    title: "轮数",
    dataIndex: "epoch",
    key: "epoch",
  },
  {
    title: "步数",
    dataIndex: "step",
    key: "step",
  },
  {
    title: "损失",
    key: "loss",
    dataIndex: "loss",
  },

  {
    title: "训练检出率",
    key: "trainRecall",
    dataIndex: "trainRecall",
  },
  {
    title: "训练准确率",
    key: "trainAccuracy",
    dataIndex: "trainAccuracy",
  },
  {
    title: "验证检出率",
    key: "valRecall",
    dataIndex: "valRecall",
  },
  {
    title: "验证准确率",
    key: "valAccuracy",
    dataIndex: "valAccuracy",
  },
  {
    title: "字符准确率",
    key: "wordAccuracy",
    dataIndex: "wordAccuracy",
  },
  {
    title: "时间",
    key: "createTime",
    dataIndex: "createTime",
  },
];
const innerColumns = [
  {
    title: "序号",
    dataIndex: "index",
    key: "index",
    width: 100,
    align: "center",
  },
  {
    title: "开始时间",
    dataIndex: "startTime",
    key: "startTime",
    align: "center",
  },
  {
    title: "结束时间",
    dataIndex: "completeTime",
    key: "completeTime",
    align: "center",
  },
];
export default {
  name: "TaskManagement",
  components: {
    CommentHeader,
    Info,
    TrainConfig,
    // TrainConfig_classify,
    TaskForm,
    TrainLog,
    modelChoose,
    JsonEditor,
    TrainValidate,
  },
  data() {
    return {
      loading: false,
      innerColumns,
      TaskStatics: null,
      columns,
      serchProjectId: "0",
      networkModelList: [],
      networkModelTypeList: [],
      resourceList: [],
      projectList: [],
      taskStatics: {
        awaitCount: "0个",
        prepCount: "0个",
        traningCount: "0个",
        completeCount: "0个",
      },
      queryParam: {
        status: "-1",
        projectId: "0",
      },
      paging: {
        pageSize: 15,
        totalRecords: 1,
        pageIndex: 1,
      },
      data,
      visible: false,
      confirmLoading: false,
      mdl: null,
      title: "",
      visible1: false,
      confirmLoading1: false,
      mdl1: null,
      title1: "",
      currentTaskId: 0,
      isConfig: false,
      currentConfigId: 0,
      updateStatusProgressTime: null,
      getTrainLogTime: null,
      getdefaultLogTime: null,
      visible2: false,
      trainLogLoading: false,
      mdl2: null,
      title2: "实时训练记录",
      logId1: 0,
      logId2: 0,
      logData: [],
      logColumns: [],
      showAlertMsg: true,
      showNetworkModelType: false,
      showAugmentation: false,
      fathertitle: "训练管理",
      childtitle: "任务管理(训练)",
      path: "/train/project-list",
      isopenvalue: false,
      isshowChooseModel: false,
      modelList: [],
      showSeparate: false,
      showrow: true,
      showDown: false,
      showDown2: false,
      showJson: false,
      // jsoneditor编辑器
      jsonData: "",
      visible6: false,
      configId: 0,
      numcc: 0,
      showSemiSupervised: false,
      trainValidateVisible: false,
      trainValidateLoading: false,
      validate: null,
      currentProjectId: 0,
    };
  },

  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    buildInnerText(record) {
      // record.trainTaskDetailBo
      var arr = [];
      if (record.detailBoList) {
        arr = record.detailBoList.map((item, index) => {
          return {
            index: index + 1,
            key: item.startTime,
            startTime: item.startTime,
            completeTime: item.completeTime,
          };
        });
      }
      return arr;
    },
    onChange(value, record) {
      console.log(value);
      console.log(record);
    },
    errorMsg(msg) {
      projectManagement.getError(msg.id).then((res) => {
        console.log(res);
        this.$error({
          title: "错误信息提示",
          content: `${res.data}`,
        });
      });
    },
    changeUploadJson(value) {
      this.jsonData = value;
    },
    handleOkJson(value) {
      const self = this;
      const form = this.$refs.trainConfig.form;
      this.visible6 = false;
      var config = {};
      this.loadConfig(this.configId).then((res) => {
        config = res.data == null ? {} : res.data;
        config.jsonConfig = JSON.stringify(value);
        if (self.isConfig) {
          // 新增
          task
            .updateConfig({
              ...config,
              taskId: this.configId,
              id: config.id,
            })
            .then((r) => {
              this.jsonData = "";
            });
        } else {
          task.addConfig({ ...config, taskId: this.configId }).then((r) => {
            this.jsonData = "";
          });
        }
      });
      // this.jsonData = ''
    },
    handleCancelJson() {
      this.visible6 = false;
      this.jsonData = "";
    },
    chooseOk() {},
    chooseCancel() {},
    onClose(e) {
      console.log(e, "I was closed.");
    },
    handleCancel() {
      if (
        this.$refs.trainConfig != undefined ||
        this.$refs.trainConfig.form != undefined
      ) {
        this.$refs.trainConfig.form.resetFields();
      }
      this.visible = false;
    },
    handleOk() {
      const form = this.$refs.trainConfig.form;
      const self = this;
      form.validateFields((errors, values) => {
        // console.log(values);
        if (!errors) {
          console.log("values", values);
          new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve();
            }, 500);
          }).then((res) => {
            var copyValues = values;
            if (values.rotateAugmentation == 0) {
              copyValues.rotateAugmentation = false;
            } else {
              copyValues.rotateAugmentation = true;
            }
            if (values.colourAugmentation == 0) {
              copyValues.colourAugmentation = false;
            } else {
              copyValues.colourAugmentation = true;
            }
            if (self.isConfig) {
              // 新增

              task
                .updateConfig({
                  ...copyValues,
                  taskId: this.currentTaskId,
                  id: self.currentConfigId,
                })
                .then((r) => {
                  self.visible = false;
                  self.confirmLoading = false;
                  form.resetFields();
                  self.$message.success("训练参数配置更新成功");
                });
            } else {
              task
                .addConfig({ ...copyValues, taskId: this.currentTaskId })
                .then((r) => {
                  self.visible = false;
                  self.confirmLoading = false;
                  form.resetFields();
                  self.$message.success("训练参数配置成功");
                });
            }
            setTimeout(() => {
              self.loadTask();
            }, 500);
          });
        } else {
          this.confirmLoading = false;
        }
      });
    },
    handleCancel1() {
      this.visible1 = false;
      if (
        this.$refs.taskForm !== undefined ||
        this.$refs.taskForm.form != undefined
      ) {
        this.$refs.taskForm.form.resetFields();
      }
    },
    handleOk1() {
      const form = this.$refs.taskForm.form;
      // this.confirmLoading1 = true;
      const self = this;
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log("values", values);
          if (self.currentTaskId > 0) {
            // 修改 e.g.
            new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve();
              }, 500);
            }).then((res) => {
              task._update({ ...values, id: self.currentTaskId }).then((r) => {
                self.visible1 = false;
                self.confirmLoading1 = false;
                form.resetFields();
                self.loadTask();
                self.$message.info("更新任务成功");
              });
            });
          } else {
            // 新增
            new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve();
              }, 500);
            }).then((res) => {
              // console.log(values);
              // console.log(this.projectList);
              var value = this.projectList.filter((item) => {
                return item.name == values.projectId;
              });
              // console.log(value[0].id)
              // console.log(this.projectList);
              task._add({ projectId: value[0].id }).then((r) => {
                self.visible1 = false;
                self.confirmLoading1 = false;
                form.resetFields();
                self.loadTask();
                this.$message.info("创建成功");
              });
            });
          }
        } else {
          this.confirmLoading1 = false;
        }
      });
    },
    handleCancel2(value) {
      this.visible2 = false;
      this.isopenvalue = value;
      clearInterval(this.getTrainLogTime);
      clearInterval(this.getdefaultLogTime);
    },
    handleOk2() {
      this.visible2 = false;
    },
    add() {
      const self = this;
      this.title1 = "创建任务";
      this.currentTaskId = 0;
      self.visible1 = true;
      this.$nextTick((r) => {
        this.mdl1 = {};
        if (self.projectList.length > 0) {
        }
        // self.mdl1.projectId = self.projectList[0].id;
        self.mdl1.projectId = self.projectList[0].name;
      });
    },
    start(record) {
      const self = this;
      if (record.status === 1 || record.status === 4) {
        this.$message.warning("当前任务状态不可执行开始训练操作");
      } else {
        this.$confirm({
          title: `你想要开始执行任务的训练吗?`,
          content: `当你点击确认按钮时, 这个对话框将会在执行成功后关闭`,
          okText: "确定",
          cancelText: "取消",
          onOk() {
            return new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve();
              }, 500);
            })
              .then((res) => {
                task.startTraining({ id: record.id }).then((r) => {
                  self.loadTask();
                });
              })
              .catch(() => console.log("小猪，出错啦，休息会吧!"));
          },
          autoFocusButton: null,
        });
      }
    },
    setBreak(record) {
      const self = this;
      this.$confirm({
        title: `你想要中断该任务的训练吗?`,
        content: `当你点击确认按钮时, 这个对话框将会在执行成功后关闭`,
        okText: "确定",
        cancelText: "取消",
        onOk() {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve();
            }, 500);
          })
            .then((res) => {
              task.setBreak({ id: record.id }).then((r) => {
                self.loadTask();
              });
            })
            .catch(() => console.log("小猪，出错啦，休息会吧!"));
        },
        autoFocusButton: null,
      });
    },
    edit(record) {
      const self = this;
      this.title1 = "更新任务";
      this.currentTaskId = record.id;
      this.$nextTick((r) => {
        self.mdl1 = {};
        if (self.projectList.length > 0) {
          var value = self.projectList.filter((item) => {
            return item.id == record.projectId;
          });
          // self.mdl1.projectId = record.projectId + "";
          self.mdl1.projectId = value[0].name;
        }
      });
      self.visible1 = true;
    },
    remove(record) {
      const self = this;
      this.$confirm({
        title: `你想要删除此任务吗?`,
        content: `当你点击确认按钮时, 这个对话框将会在删除成功时关闭`,
        okText: "确定",
        cancelText: "取消",
        onOk() {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve();
            }, 500);
          })
            .then((res) => {
              task.remove({ id: record.id }).then((r) => {
                self.loadTask();
              });
            })
            .catch(() => console.log("小猪，出错啦，休息会吧!"));
        },
        autoFocusButton: null,
      });
    },
    loadProjecList() {
      const self = this;
      projectManagement.getAllProject().then((r) => {
        this.projectList = [];
        for (let index = 0; index < r.data.length; index++) {
          const element = r.data[index];
          self.projectList.push({ id: element.id + "", name: element.name });
        }
        this.projectList.sort((a, b) =>
          a.name.localeCompare(b.name, "zh-Hans-CN", { sensitivity: "accent" })
        );
      });
    },
    loadTaskStatics() {
      const self = this;
      task
        .getTaskStatics()
        .then((r) => {
          self.taskStatics.awaitCount = r.data.awaitDealCount + "个";
          self.taskStatics.prepCount = r.data.prepTaskCount + "个";
          self.taskStatics.traningCount = r.data.trainingTaskCount + "个";
          self.taskStatics.completeCount = r.data.completeTaskCount + "个";
        })
        .catch((e) => {
          clearInterval(this.TaskStatics);
        });
    },
    loadTask() {
      const self = this;
      task
        .getPage({
          ...self.queryParam,
          pageIndex: self.paging.pageIndex,
          pageSize: self.paging.pageSize,
        })
        .then((res) => {
          self.data = [];
          if (
            res.data !== undefined &&
            res.data != null &&
            res.data.list.length > 0
          ) {
            self.paging.totalRecords = res.data.totalRecords;
            for (let index = 0; index < res.data.list.length; index++) {
              const element = res.data.list[index];
              self.data.push({
                key: element.id,
                id: element.id,
                projectId: element.projectId,
                networkModelName: element.networkModelName,
                networkModelTypeName: element.networkModelTypeName,
                detailBoList: element.detailBoList
                  ? element.detailBoList
                  : null,
                networkModel:
                  element.networkModelName +
                  "                         " +
                  element.networkModelTypeName,
                projectName: element.projectName,
                submitTime: element.submitTime,
                resourceName: element.resourceName,
                currentStartTime: element.currentStartTime,
                lastCompleteTime: element.lastCompleteTime,
                downloadBmodel: element.downloadBmodel,
                progress: {
                  status: "exception",
                  value: element.trainProgress,
                },
                status: element.status,
              });
            }
          } else {
            self.paging.totalRecords = 0;
            self.paging.pageIndex = 1;
          }
        });
    },
    loadTask2(status) {
      this.queryParam.status = status;
      this.loadTask();
    },
    selectProject(value, option) {
      console.log(value);
      this.queryParam.projectId = value;
      // if (value == "全部项目") {
      //   this.queryParam.projectId = "0";
      // } else {
      //   var num = this.projectList.filter((item) => {
      //     return item.name == value;
      //   });
      //   this.queryParam.projectId = num[0].id;
      //   this.serchProjectId = num[0].name;
      // }
      this.loadTask();
    },
    loadNetworkModelTypeList(taskId) {
      const self = this;
      networkmodeltype.getList(taskId).then((res) => {
        self.networkModelTypeList = res.data;
      });
      // networkmodeltype.getAll().then((res) => {
      //   self.networkModelTypeList = res.data;
      // });
    },

    async loadResourceList(id) {
      const resultData = [];
      const dataUrl =
        requestUrl + "/train/rest/label_file/get_label_resource_list/" + id;
      try {
        const res = await request({
          url: dataUrl,
          method: "get",
        });

        return res;
      } catch (err) {
        console.log(err);
      }
      return resultData;
    },
    async loadConfig(id) {
      const resultData = null;
      const dataUrl = requestUrl + "/train/rest/task/get_task_config/" + id;
      try {
        const res = await request({
          url: dataUrl,
          method: "get",
        });

        return res;
      } catch (err) {
        console.log(err);
      }
      return resultData;
    },
    /**
     * 配置参数
     */
    configParams(record) {
      console.log(record);
      this.currentProjectId = record.projectId;
      this.$refs.trainConfig.form.resetFields();
      const self = this;
      this.title = "配置参数";
      // if(record.networkModelName == "分类模型算法"||
      // record.networkModelName =="粮食模型算法" ||
      // record.networkModelName == "瓶子瓶盖" ||
      // record.networkModelName == "分割模型算法"
      // ){
      //   this.showrow = true
      // }else {
      //   this.showrow = false
      // }
      if (
        record.networkModelName === "分类模型算法" ||
        record.networkModelName === "粮食模型算法"
        // ||
        // record.networkModelName === "棉花" ||
        // record.networkModelName === "分割模型算法"
      ) {
        this.showNetworkModelType = true;
        // this.showNetworkModelType = true;
      } else {
        this.showNetworkModelType = false;
        // this.showNetworkModelType = false;
      }
      if (record.networkModelName === "瓶子瓶盖") {
        this.showAugmentation = true;
      } else {
        this.showAugmentation = false;
      }
      if (record.networkModelName === "分割模型算法") {
        this.showSeparate = true;
      } else {
        this.showSeparate = false;
      }
      this.currentTaskId = record.id;
      // 排序
      this.loadResourceList(record.projectId).then((rrr) => {
        this.resourceList = [];
        if (rrr.data.list != null) {
          for (let index = 0; index < rrr.data.list.length; index++) {
            const element = rrr.data.list[index];
            self.resourceList.push({
              id: element.id,
              name: record.projectName + "/" + element.name,
            });
          }
          self.resourceList.sort((a, b) =>
            a.name.localeCompare(b.name, "zh-Hans-CN", {
              sensitivity: "accent",
            })
          );
        }
        self.loadConfig(record.id).then((yyy) => {
          console.log("r:" + JSON.stringify(yyy));

          // console.log(yyy.data.semiSupervisedFlag)
          if (yyy.data == null) {
            networkmodeltype.getList(record.id).then((res) => {
              self.networkModelTypeList = res.data;
              self.isConfig = false;
              console.log(record);
              if (record.networkModelName === "粮食模型算法") {
                // 设置初始值
                self.mdl = {
                  modelNum: 1,
                  trainFrequency: 200,
                  rotateAugmentation: 0,
                  colourAugmentation: 0,
                  networkModelTypeId: 1,
                  generateBmodel: 0,
                  semiSupervisedFlag: 0,
                };
              } else if (record.networkModelName === "分类模型算法") {
                self.mdl = {
                  modelNum: 1,
                  trainFrequency: 100,
                  rotateAugmentation: 0,
                  colourAugmentation: 0,
                  generateBmodel: 0,
                  semiSupervisedFlag: 0,
                  networkModelTypeId: 1,
                };
              } else if (record.networkModelName === "瓶子瓶盖") {
                self.mdl = {
                  modelNum: 1,
                  rotateAugmentation: 0,
                  colourAugmentation: 0,
                  generateBmodel: 0,
                  semiSupervisedFlag: 0,
                  networkModelTypeId: 53,
                };
              } else if (record.networkModelName === "分割模型算法") {
                self.mdl = {
                  modelNum: 1,
                  numClass: 1,
                  stride: 1,
                  rotateAugmentation: 0,
                  generateBmodel: 0,
                  semiSupervisedFlag: 0,
                  colourAugmentation: 0,
                };
              } else {
                self.mdl = {
                  rotateAugmentation: 0,
                  colourAugmentation: 0,
                  semiSupervisedFlag: 0,
                  generateBmodel: 0,
                };
              }

              if (record.bm1684x == null || record.bm1684x == undefined) {
                this.$set(self.mdl, "bm1684x", 0);
              }

              self.currentConfigId = 0;
            });
            // self.loadNetworkModelTypeList(record.id);
          } else {
            //  console.log(yyy.data);
            if (yyy.data.semiSupervisedFlag == null)
              yyy.data.semiSupervisedFlag = false;
            networkmodeltype.getList(record.id).then((res) => {
              self.networkModelTypeList = res.data;
              var copyValues = yyy.data;
              if (yyy.data.modelNum == null) {
                copyValues.modelNum = 1;
              }
              // if (yyy.data.outputBatchSize == null) {
              //   copyValues.outputBatchSize = 1;
              // }

              if (yyy.data.rotateAugmentation == null) {
                copyValues.rotateAugmentation = 0;
              }
              if (yyy.data.colourAugmentation == null) {
                copyValues.colourAugmentation = 0;
              }
              if (yyy.data.rotateAugmentation == true) {
                copyValues.rotateAugmentation = 1;
              } else {
                copyValues.rotateAugmentation = 0;
              }
              if (yyy.data.colourAugmentation == true) {
                copyValues.colourAugmentation = 1;
              } else {
                copyValues.colourAugmentation = 0;
              }
              self.mdl = copyValues;
              if (self.mdl.generateBmodel == null) {
                self.mdl.generateBmodel = 0;
              }

              if (self.mdl.semiSupervisedFlag == null) {
                self.mdl.semiSupervisedFlag = 0;
              }

              if (self.mdl.generateBmodel) {
                self.mdl.generateBmodel = 1;
              } else {
                self.mdl.generateBmodel = 0;
              }

              if (self.mdl.semiSupervisedFlag) {
                self.mdl.semiSupervisedFlag = 1;
              } else {
                self.mdl.semiSupervisedFlag = 0;
              }
              if (self.mdl.bm1684x) {
                self.mdl.bm1684x = 1;
              } else {
                self.mdl.bm1684x = 0;
              }

              // console.log(self.mdl);
              self.isConfig = true;
              self.currentConfigId = yyy.data.id;

              // // if (self.isConfig) {
              //   setTimeout(() => {
              //      self.visible = true;
              //     self.$refs.trainConfig.form.setFieldsValue({
              //       ...self.mdl
              //     });

              //   }, 200);
              // } else {
              //   // self.mdl = { ...self.mdl };
              //   // console.log("sss:" + self.mdl.semiSupervisedTrainCount);
              //   // self.visible = true;
              // }
            });
          }
          self.$nextTick(() => {
            self.visible = true;
          });
        });
      });
    },
    configParams2(record) {
      this.configId = record.id;
      this.loadConfig(record.id).then((res) => {
        this.jsonData = "";
        if (res.data == null) {
          this.isConfig = false;
        } else {
          this.isConfig = true;
        }
        console.log(res.data);
        if (
          res.data == null ||
          res.data.jsonConfig == "null" ||
          res.data.jsonConfig == null
        ) {
          this.jsonData = JSON.stringify({});
        } else {
          this.jsonData = JSON.stringify(JSON.parse(res.data.jsonConfig));
        }
        this.visible6 = true;
        setTimeout(() => {
          this.$refs.jsonEditor.$refs.editor.formatCode();
        }, 50);
      });
    },

    updateStatusProgress() {
      var ids = [];
      const self = this;
      if (this.data != null && this.data.length > 0) {
        ids = this.data.map((item) => {
          return item.id;
        });
        task
          .getListStatus(ids)
          .then((r) => {
            for (let index = 0; index < r.data.length; index++) {
              const element = r.data[index];
              self._updateStatusProgress(
                self.data,
                element.id,
                element.status,
                element.trainProgress,
                element.currentStartTime
              );
            }
          })
          .catch((e) => {
            clearInterval(this.updateStatusProgressTime);
          });
      }
    },
    _updateStatusProgress(data, id, status, progress, startTime) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (element.id === id) {
          if (element.status !== status) element.status = status;
          element.progress.value = progress;
          element.currentStartTime = startTime;
        }
      }
    },

    /**
     * 训练验证集
     * @param {*} record
     */
    openTrainValidateSet(record) {
      this.currentTaskId = record.id;
      this.trainValidateVisible = true;
      this.trainValidateLoading = false;
      this.validate = {
        currentTaskId: record.id,
      };
    },

    handleValidate() {
      this.trainValidateVisible = false;
    },

    async openLog(item) {
      this.trainLogLoading = true;
      this.currentTaskId = item.id;
      this.logId1 = 0;
      this.logId2 = 0;
      const self = this;
      this.visible2 = true;
      this.logData = [];
      console.log(item);
      clearInterval(this.getTrainLogTime);
      clearInterval(this.getdefaultLogTime);
      // const { data } = await task.defaultgetTrainLog({
      //   taskId: self.currentTaskId,
      //   logId: self.logId1,
      // });
      // const value = await task.defaultgetTrainLog2({
      //   taskId: self.currentTaskId,
      //   logId: self.logId1,
      // });
      // console.log(value);
      // self.logColumns = [];
      // for (var key in data[0]) {
      //   self.logColumns.push({
      //     dataIndex: key,
      //     key: key,
      //     title: key,
      //   });
      // }
      new Promise((reslove, reject) => {
        setTimeout(() => {
          self.logColumns = lcolunmns;
          reslove();
        }, 500);
      }).then(() => {
        if (self.isopenvalue == false) {
          // this.logData = [];

          // 训练记录自定义显示表格头部接口在这里写，然后传给TrainLog.vue,通过父传子
          self.getdefaultLogTime = setInterval(() => {
            self.getdefaultlog(self);
          }, 1000);
        } else {
          self.getTrainLogTime = setInterval(() => {
            self.getLog(self);
          }, 1000);
        }
      });
    },
    getLog(self) {
      task
        .getTrainLog({ taskId: self.currentTaskId, logId: self.logId2 })
        .then((r) => {
          var flag = false;
          this.trainLogLoading = false;
          if (r.data != null) {
            self.logId2 = r.data.id;
            if (self.isopenvalue == true) {
              self.logData.unshift(r.data);
            }
          } else {
            return;
          }
        })
        .catch((e) => {
          clearInterval(this.getTrainLogTime);
        });
    },
    getdefaultlog(self) {
      task
        .defaultgetTrainLog({ taskId: self.currentTaskId, logId: self.logId1 })
        .then((r) => {
          var flag = false;
          this.trainLogLoading = false;
          if (r.data != null) {
            // self.logId1 = r.data.id;
            // console.log(r.data);
            if (self.isopenvalue == false) {
              // var arr = []
              // for(let i =0;i<r.data.length;i++){
              //   arr.unshift(r.data[i])
              // }

              self.logData = r.data.reverse();
            } else {
              self.logData = [];
            }
          } else {
            return;
          }
        });
    },
    isopen(value) {
      this.isopenvalue = value;
      const self = this;
      this.trainLogLoading = true;
      clearInterval(this.getTrainLogTime);
      clearInterval(this.getdefaultLogTime);
      if (this.isopenvalue == false) {
        this.logData = [];
        this.getdefaultLogTime = setInterval(() => {
          self.getdefaultlog(self);
        }, 1000);
      } else {
        this.logId2 = 0;
        this.logData = [];
        this.getTrainLogTime = setInterval(() => {
          self.getLog(self);
        }, 1000);
      }
    },
    downloadTrainModel(record) {
      const userid = localStorage.getItem("user_id");
      let url;
      // console.log(userid);
      if (userid == "1b65360154b0447884fb707e9a89e183") {
        url =
          requestUrl +
          "/train/rest/file/download_train_model_onnx/" +
          record.id;
        if (this.$isEE) {
          this.inEEdown(url, 2, record.id);
          return;
        }
        window.location.href = url;
      } else {
        url = requestUrl + "/train/rest/file/download_train_model/" + record.id;
        if (this.$isEE) {
          this.inEEdown(url, 1, record.id);
          return;
        }
        window.location.href = url;
      }
    },
    async inEEdown(filePath, type, id) {
      // 1 onnx 非加密  2  onnx 加密  3 bmodel 非加密  4 bmodel 加密 5 trt 非加密  6 trt加密
      this.loading = true;
      const result = await task.getModelName({ id, type });
      console.log(result);
      this.$ipc
        .invoke(ipcApiRoute.handlerSaveFile, {
          filePath,
          name: result.data,
        })
        .then((res) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    downloadTrainModel2(record) {
      const userid = localStorage.getItem("user_id");
      // console.log(userid);
      if (
        userid == "1e18f0a07b6647a692c8a9a4b29dd875" ||
        userid == "00f17ec113f74a4180e58d647f0352a1" ||
        userid == "e04381fc368b456caff674821d1f21fc"
      ) {
        if (this.$isEE) {
          this.inEEdown(
            requestUrl +
              "/train/rest/file/download_train_model_onnx/" +
              record.id,
            2,
            record.id
          );
          return;
        }
        window.location.href =
          requestUrl +
          "/train/rest/file/download_train_model_onnx/" +
          record.id;
      }
    },
    downloadTrainBModel(record) {
      const url =
        requestUrl + "/train/rest/file/download_train_b_model/" + record.id;
      if (this.$isEE) {
        this.inEEdown(url, 4, record.id);
        return;
      }
      window.location.href = url;
    },
    downloadTrainBModel2(record) {
      const url =
        requestUrl + "/train/rest/file/download_train_b_model2/" + record.id;
      if (this.$isEE) {
        this.inEEdown(url, 3, record.id);
        return;
      }
      window.location.href = url;
    },

    downloadTrtTrainModel(record) {
      const url =
        requestUrl +
        "/train/rest/file/download_trt_des_train_model/" +
        record.id;
      if (this.$isEE) {
        this.inEEdown(url, 5, record.id);
        return;
      }
      window.location.href = url;
    },
    downloadTrtTrainModel2(record) {
      const url =
        requestUrl +
        "/train/rest/file/download_trt_ens_train_model/" +
        record.id;
      if (this.$isEE) {
        this.inEEdown(url, 6, record.id);
        return;
      }
      window.location.href = url;
    },

    onChangepage(page, pageSize) {
      this.paging.pageIndex = page;
      this.loadTask();
      clearInterval(this.updateStatusProgressTime);
      this.updateStatusProgressTime = setInterval(
        this.updateStatusProgress,
        1000
      );
    },
    // window.location.href = requestUrl + '/train/rest/file/download_train_model/' + record.id
  },
  mounted() {
    this.loadTaskStatics();
    this.loadProjecList();
    this.loadTask();
    var user_name = localStorage.getItem("user_name");
    if (user_name == "admin" || user_name == "user_2") {
      this.showDown = true;
    } else {
      this.showDown = false;
    }
    if (
      user_name == "admin" ||
      user_name == "user_2" ||
      user_name == "lichunli"
    ) {
      this.showJson = true;
    } else {
      this.showJson = false;
    }
    // this.loadNetworkModelList()
    // this.loadNetworkModelTypeList();
    this.TaskStatics = setInterval(this.loadTaskStatics, 1000);
    this.updateStatusProgressTime = setInterval(
      this.updateStatusProgress,
      1000
    );
  },
  beforeDestroy() {
    console.log("销毁定时器");
    clearInterval(this.updateStatusProgressTime);
    clearInterval(this.getTrainLogTime);
    clearInterval(this.TaskStatics);
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
